import Vue from 'vue';
import notificationService from '@/services/notificationService';
import { Module } from 'vuex';
import projectStatussesRepos from '@/services/projects/projectstatussesRepository';
import projectsRepo from '@/services/projectsRepository';

const projectsModule: Module<any, any> = {
    namespaced: true,
    state: {
        initialised: false,
        saving: false,
        loading: false,
        statusses: [],
        items: {},
    },
    getters: {
        items: (state: any) => state.items.data,
        statusses : (state: any) => state.statusses,
        getStatusName: (state: any) => (value: number) => {
            const status: IProjectStatus = state.statusses.find((o: IProjectStatus) => o.value === value);
            return status ?  status.name : '';
        },
        getStatusIsDeclined: (state: any) => (value: number) => {
            const status: IProjectStatus = state.statusses.find((o: IProjectStatus) => o.value === value);
            if (!status) {
                return false;
            }

            return status.status === 5 ? true : false; // ProjectStatus.declined
        },
        loading: (state) => state.loading,
    },
    mutations: {
        setItems(state, objects) {
            state.initialised = true;
            state.items = objects;
        },
        setStatusses(state, objects) {
            state.statusses = objects;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setInitialised(state) {
            state.initialised = true;
        },
        setSaving(state, value) {
            state.saving = value;
        },
    },
    actions: {
        async fetch({ state, dispatch }) {
            if (!state.initialised) {
                await dispatch('loadStatusses');
                await dispatch('load');
            }
        },
        async loadStatusses({ commit }) {
            commit('setLoading', true);
            try {
                const res = await projectStatussesRepos.get();
                commit('setStatusses', res.data as IProjectStatus[]);
            } catch (err) {
                notificationService.failedToLoad();
            } finally {
                commit('setLoading', false);
            }
        },
        async load({ commit }) {
            commit('setLoading', true);
            try {
                const loadOptions: any = {};
                loadOptions.take = 100000;
                loadOptions.searchValue = '';
                const res = await projectsRepo.lookup(loadOptions);
                commit('setItems', res.data);
            } catch (err) {
                notificationService.failedToLoad();
            } finally {
                commit('setLoading', false);
            }
        },
        async createStatus({ commit }, object: IProjectStatus) {
            commit('setSaving', true);
            try {
                const res = await projectStatussesRepos.create(object);
                commit('setStatusses', res.data as IProjectStatus[]);
                notificationService.saved();
            } catch (err) {
                notificationService.showAxiosError(err);
                return false;
            } finally {
                commit('setSaving', false);
            }
            return true;
        },
        async updateStatus({ commit }, object: IProjectStatus) {
            commit('setSaving', true);
            try {
                const res = await projectStatussesRepos.update(object);
                commit('setStatusses', res.data as IProjectStatus[]);
                notificationService.saved();
                return true;
            } catch (err) {
                notificationService.showAxiosError(err);
                return false;
            } finally {
                commit('setSaving', false);
            }
        },
        async updateMultipleStatussesOrder({ commit }, objectList: IProjectStatus[]) {
            commit('setSaving', true);
            try {
                const res = await projectStatussesRepos.updateOrderList(objectList);
                commit('setStatusses', res.data as IProjectStatus[]);
                notificationService.saved();
                return true;
            } catch (err) {
                notificationService.showAxiosError(err);
                return false;
            } finally {
                commit('setSaving', false);
            }
        },
        async deleteStatus({ commit, dispatch }, {oldValue, newValue} ) {
            commit('setSaving', true);
            try {
                await projectStatussesRepos.delete(oldValue, newValue);
                dispatch('loadStatusses');
                notificationService.saved();
            } catch (err) {
                notificationService.showAxiosError(err);
                return false;
            } finally {
                commit('setSaving', false);
            }
            return true;
        },
    },
};

export default projectsModule;
